import { ISOPROProduct } from '~/models';

const TO = 'technik-hbau@pohlcon.com';
const CC = 'digital@pohlcon.com';

export function emailCreator (selectedProduct: ISOPROProduct, contents: string[]): string {
  const subject = `[ λeq ] - ${selectedProduct.rowKey}`;

  const body = `
${contents[0]}  ${selectedProduct.rowKey}
${contents[1]}`;

  return `mailto:${TO}?subject=${subject}&cc=${CC}&body=${body}`;
}
